import React from 'react';
import PropTypes from 'prop-types';
import {
  FiHome, FiPlusSquare, FiList, FiActivity,
  FiShoppingCart, FiMinusCircle, FiSearch, FiClock, FiPackage,
} from 'react-icons/fi';
import { Link } from 'react-router-dom';

function InventoryMenu({ closeMenu }) {
  const handleClick = () => {
    if (closeMenu) closeMenu(); // only used on mobile
  };

  return (
    <div className="bg-gray-800 text-white w-64 min-h-screen p-4">
      <h2 className="text-xl font-bold mb-6 p-2 border-b border-gray-700 flex items-center">
        <FiPackage className="mr-2" />
        Inventory System
      </h2>

      <nav>
        <ul className="space-y-2">
          <li>
            <Link
              to="/inventory/dashboard"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiHome className="mr-3" />
              Dashboard
            </Link>
          </li>

          <li>
            <Link
              to="/inventory/add-new-product"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiPlusSquare className="mr-3" />
              Add New Product
            </Link>
          </li>

          <li>
            <Link
              to="/inventory/inventory-table"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiList className="mr-3" />
              Product List
            </Link>
          </li>

          <li>
            <Link
              to="/inventory/stock-movement-log"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiActivity className="mr-3" />
              Movement Log
            </Link>
          </li>

          <li>
            <Link
              to="/inventory/purchase"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiShoppingCart className="mr-3" />
              Purchase
            </Link>
          </li>

          <li>
            <Link
              to="/inventory/issue"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiMinusCircle className="mr-3" />
              Issue Stock
            </Link>
          </li>

          <li>
            <Link
              to="/inventory/search-product"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiSearch className="mr-3" />
              Search Products
            </Link>
          </li>
          <li>
            <Link
              to="/inventory/orders"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiList className="mr-3" />
              Orders
            </Link>
          </li>
          <li>
            <Link
              to="/inventory/kitchen-orders"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiClock className="mr-3" />
              Kitchen Orders
            </Link>
          </li>

          <li>
            <Link
              to="/inventory/future-implement-plans"
              onClick={handleClick}
              className="flex items-center p-2 rounded hover:bg-gray-700 transition"
            >
              <FiClock className="mr-3" />
              Future Plans
            </Link>
          </li>
        </ul>
      </nav>

      {/* Current User Section */}
      <div className="mt-8 pt-4 border-t border-gray-700">
        <div className="flex items-center p-2">
          <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-2">
            <span className="text-sm font-medium">AD</span>
          </div>
          <div>
            <p className="text-sm font-medium">Admin User</p>
            <p className="text-xs text-gray-400">Inventory Manager</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Validate props
InventoryMenu.propTypes = {
  closeMenu: PropTypes.func, // optional, used for mobile drawer
};

InventoryMenu.defaultProps = {
  closeMenu: undefined,
};

export default InventoryMenu;
